<template>
    <div>
        <Modal v-model="visible" width="800px" title="业务员" :footer-hide="true" :mask-closable="false" class="my-modal top">
            <div class="tools-box samll">
                <Button type="primary" @click="$refs.addUser.open(formData)">新增业务员</Button>
                <Button v-if="$units.pointAction('operate_5_4')" type="warning" @click="signIn">批量签到导入</Button>
            </div>
            <div class="table-box">
                <loading :isShow="listLoading" />
                <Table :columns="columns" :data="tableData">
                    <template slot-scope="{ row }" slot="signIn">
                        <i-switch v-model="row.signIn" true-value="1" false-value="0"
                            @on-change="switchChange(row, $event)"></i-switch>
                    </template>
                    <template slot-scope="{ row }" slot="action">
                        <div class="detail">
                            <div @click="del(row)">
                                <span>删除</span>
                            </div>
                        </div>
                    </template>
                </Table>
                <div class="pageBox">
                    <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList"
                        style="text-align: center" />
                </div>
            </div>
        </Modal>
        <!-- 修改基本信息  -->
        <addUser ref="addUser" @suceess="searchAjax()"></addUser>
        <import-tool ref="importTool" @success="searchAjax()"></import-tool>
    </div>
</template>

<script>
import addUser from './addUser';
import { pageTool } from '@/api/mixins';
import importTool from '@/components/commons/importTool/index2'
export default {
    components: {
        importTool,
        addUser
    },
    mixins: [pageTool],
    props: [],
    data() {
        return {
            visible: false,
            listLoading: false,
            loading: false,
            formData: {},
            columns: [
                {
                    title: '序号',
                    type: 'index',
                    width: 80,
                    align: 'center'
                },
                {
                    title: '工号',
                    key: 'staffNo',
                    align: 'center'
                },
                {
                    title: '姓名',
                    key: 'agentName',
                    align: 'center'
                },
                {
                    title: '是否签到',
                    slot: 'signIn',
                    align: 'center',
                    width: '100'
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: '100'
                }
            ]
        };
    },
    created() { },
    methods: {
        setReqParams(params){
            params.apiPermissionCode = 'operate_5_2';
        },
        signIn() {
            const dic = JSON.parse(localStorage.dic)['USER_SIGN_EXPORT']
            const key = Object.getOwnPropertyNames(dic)[0];
            this.$refs.importTool.open({
                params: {},
                uploadParams: {
                    trainId: this.searchParams.trainId
                },
                template: key,
                templateName: dic[key],
                uploadUrl: "/buz/userTrain/batchSign",
                errorUrl: "/buz/userTrain/exportErrorBatchSign",
                apiPermissionCode:'operate_5_4'
            })
        },
        open(data = {}) {
            this.formData.id = data.id;
            this.searchParams.trainId = data.id;
            this.visible = true;
            this.initListAjax('/buz/userTrain/read/list');
        },
        // 删除
        del(row) {
            this.$notice.inquiry('确定删除该业务员的培训记录？').then(() => {
                this.$http({
                    url: '/buz/userTrain/del',
                    type: 'get',
                    data: {
                        id: row.id
                    }
                }).then(res => {
                    this.$notice.success('删除成功');
                    this.searchAjax();
                });
            });
        },
        // 签到开关
        switchChange(item, signIn) {
            this.$http({
                type: 'POST',
                url: '/buz/userTrain/sign',
                data: {
                    id: item.id,
                    signIn
                }
            })
                .then(res => {
                    this.$notice.success('保存成功');
                })
                .catch(() => {
                    this.getList();
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.tools-box {
    margin-top: 10px;
    justify-content: flex-start;
}

.detail span {
    font-size: 13px;
}
</style>
